module.exports = __webpack_public_path__ + "img/tags.44c95385.svg";